import { gql } from 'graphql-tag';

export const CREATE_QUOTE_PROPOSAL_PREVIEW = gql`
  mutation CreateQuoteProposalPreview($input: CreateQuoteProposalPreviewInput!) {
    result: createQuoteProposalPreview(input: $input) {
      error
      success
      entity {
        id
      }
    }
  }
`;
